
export enum PropertyConfigType {

    /**
     * ID : Unsigned BIGINT
     */
    ID = "ID",

    /**
     * Age value, from 0 to 130
     */
    AGE = "AGE",

    /**
     * Range value
     */
    RANGE = "RANGE",

    /** STRINGS */

    /**
     * Normal string length: Max length 127
     */
    STRING = "STRING",

    /**
     * UID: Max length 50 chars
     */
    UID = "UID",

    /**
     * Email string
     */
    EMAIL = "EMAIL",

    /**
     * Password string
     */
    PASSWORD = "PASSWORD",

    /**
     * Coordinates string
     */
    COORDINATE = "COORDINATE",

    /**
     * Text area
     */
    TEXTAREA = "TEXTAREA",

    /**
     * Basic number, accepts float
     */
    NUMBER = "NUMBER",

    /**
     * Search for value, use InputSearch component
     */
    SEARCH = "SEARCH",

    /**
     * Color in hexa format
     */
    COLOR = "COLOR",

    /**
     * Phone number as string
     */
    PHONE_NUMBER = "PHONE",

    /** DATES & TIMES */

    /**
     * UnixTimestamp date
     */
    DATE = "DATE",

    /**
     * UnixTimestamp finish date
     * Will store beginOfNextDay, but keeps displaying picked date
     * Ex:
     * [27/02/2021] displayed in editor
     * value: 28/02/2021 00:00:00 UTC
     */
    FINISH_DATE = "FINISH_DATE",

    /**
     * Date interval
     * ! Only for display, cannot be used to update start and finish fields ! (TODO)
     * Finish date will be managed like FINISH_DATE type
     */
    DATE_INTERVAL = "DATE_INTERVAL",

    /** 
     * Duration 
     */
    DURATION = "DURATION",

    // TODO DURATION_IN_SECONDS

    /** 
     * UnixTimestamp, edit date + time
     */
    DATETIME = "DATETIME",

    /** 
     * Time in minutes
     */
    TIME = "TIME",

    /** 
     * Time in seconds
     */
    TIME_IN_SECONDS = "TIME_IN_SECONDS",

    /**
     * TinyMCE input text
     */
    TINYMCE = "TINYMCE",

    /** CHECKBOXES */

    /**
     * Default
     */
    CHECKBOX = "CHECKBOX",

    /**
     * Switch
     */
    SWITCH = "SWITCH",

    /**
     * Default
     */
    CHECKBOX_GROUP = "CHECKBOX_GROUP",

    /** LISTS */

    /** LIST SELECT */
    LISTSELECT = "LISTSELECT",

    /** REF LIST */
    REFLIST = "REFLIST",

    /** REF LIST ORDERED */
    REFLIST_ORDERED = "REFLIST_ORDERED",

    /** REF TABLE */
    REFTABLE = "REFTABLE",

    /** FILE SELECT */
    FILELIST = "FILELIST",

    /** EDITABLE TEXT */
    EDITABLE_TEXT = "EDITABLE_TEXT",

    /** IMAGE */
    IMAGE = "IMAGE",

    /** MINUTES_INTERVALS (ex: "06:00-14:00;22:00-06:00" ) */
    MINUTES_INTERVALS = "MINUTES_INTERVALS"
}

export const DatedPropertyConfigTypes: PropertyConfigType[] = [
    PropertyConfigType.DATE,
    PropertyConfigType.FINISH_DATE,
    PropertyConfigType.DATETIME
];

export const NumericPropertyConfigTypes: PropertyConfigType[] = [
    PropertyConfigType.AGE,
    PropertyConfigType.RANGE,
    PropertyConfigType.NUMBER,
    PropertyConfigType.DURATION,
    PropertyConfigType.TIME,
    PropertyConfigType.TIME_IN_SECONDS
];

export const BooleanPropertyConfigTypes: PropertyConfigType[] = [
    PropertyConfigType.CHECKBOX,
    PropertyConfigType.CHECKBOX_GROUP,
    PropertyConfigType.SWITCH
];

export const ReferencePropertyConfigTypes: PropertyConfigType[] = [
    PropertyConfigType.REFLIST,
    PropertyConfigType.REFLIST_ORDERED,
    PropertyConfigType.REFTABLE
];